import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { LANDING_FONTS, landingSectionTitleSx, landingSectionSubtitleSx } from '../landingVisual';

const SectionContainer = ({
  id,
  title,
  subtitle,
  children,
  bgcolor = 'background.paper',
  titleId,
  maxWidth = 'lg',
  py = { xs: 8, md: 10 },
}) => (
  <Box
    component="section"
    id={id}
    aria-labelledby={titleId}
    sx={{ py, bgcolor, fontFamily: LANDING_FONTS.sans }}
  >
    <Container maxWidth={maxWidth}>
      {title && (
        <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 5.5 } }}>
          <Typography
            id={titleId}
            variant="h3"
            component="h2"
            sx={{ ...landingSectionTitleSx, mb: subtitle ? 1.5 : 0 }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="h6" component="p" sx={landingSectionSubtitleSx}>
              {subtitle}
            </Typography>
          )}
        </Box>
      )}
      {children}
    </Container>
  </Box>
);

export default SectionContainer;
